/**
 * If is a data capture session we have a race condition between the
 * iFrame and parent JS, making events (load) for comm. unreliable.
 *
 * If we beat the other script to the punch we fall back on polling
 * until the other script catches up.
 */
if (App.hideControls) {
   const notifyParentOfLoad = function() {
      // Call parent's notifyLoad(), or poll until we can.
      window.parent.notifyLoad ? window.parent.notifyLoad() : setTimeout(notifyParentOfLoad, 200);
   };
   window.onload = notifyParentOfLoad;
}

new TitleController(
   StepsController(
      GuideData,
      StepSwitcherImmediate(),
      IntroController(GuideData, FullScreenController, PrepareEmbed),
      FullScreenController,
      ConclusionController(FullScreenController, PrepareEmbed),
      PrepareEmbed,
      Zoom
   )
);
